import { HttpInterceptor, HttpRequest, HttpHandler } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { tap } from "rxjs";

@Injectable()
export class SSRHttpDebugInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler) {
        console.log('SSR HTTP Request:', req.url);

        return next.handle(req).pipe(
            tap({
                next: () => console.log('SSR Success:', req.url),
                error: (err) => {
                    console.log('SSR Failed absolute url:', req.urlWithParams);
                    console.error('STATUS=', err.status);
                    console.error('MESSAGE=', err.message);
                    console.error('ERROR=', err.error);
                    if (err.error?.target) {
                        console.error('XHR ERROR=', err.error.target._error);
                    }
                }
            })
        );
    }
}